import type { Recipe, SavedRecipe } from '../../shared/types.ts'
import { ChevronRight } from 'lucide-react'
import { relativeTime } from '../lib/util.ts'
import { DishPhoto } from './DishPhoto.tsx'
import { Sheet } from './Sheet.tsx'

export function SavedSheet({ saved, onClose, onOpen }: {
  saved: SavedRecipe[]
  onClose: () => void
  onOpen: (r: Recipe) => void
}) {
  return (
    <Sheet title="Saved" onClose={onClose}>
      {saved.length === 0 ? (
        <p className="muted">Nothing kept yet. Star a recipe and it lands here, with its sources.</p>
      ) : (
        <div className="saved-list">
          {saved.map(({ recipe, savedAt, askedFor }) => (
            <button key={recipe.id} className="saved-row" onClick={() => onOpen(recipe)}>
              <DishPhoto src={recipe.photo} alt="" className="thumb-sm" />
              <span className="saved-main">
                <span className="saved-title">{recipe.title}</span>
                <span className="saved-meta">
                  {recipe.totalMinutes} min · serves {recipe.servings}
                  {recipe.cuisine ? ` · ${recipe.cuisine}` : ''}
                </span>
                <span className="saved-when">{relativeTime(savedAt)}{askedFor ? ` · “${askedFor}”` : ''}</span>
              </span>
              <ChevronRight size={20} strokeWidth={2.6} className="chev" />
            </button>
          ))}
        </div>
      )}
    </Sheet>
  )
}
